
import { defineComponent, ref, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "SequenceLabeling",
  setup() {
    const word = ref(
      "SHNet, Jakarta - Menteri Dalam Negeri (Mendagri) Muhammad Tito Karnavian mengingatkan pemerintah daerah (Pemda) yang angka inflasinya masih tinggi untuk segera melakukan langkah pengendalian. Pasalnya, meskipun rata-rata angka inflasi nasional relatif terkendali 2,86 persen per November, tapi kondisi inflasi di beberapa daerah masih cukup tinggi. “Sampai informasi bahwa ada daerah-daerah yang tinggi proksi inflasi, jadi Indeks Perkembangan Harganya (IPH), yang paling bawah itu yang tertinggi adalah di Sulawesi Utara (Sulut) mencapai 5 persen, ini sudah jauh di atas angka nasional,” katanya pada Rapat Koordinasi (Rakor) Pengendalian Inflasi Daerah di Gedung Sasana Bhakti Praja (SBP) Kementerian Dalam Negeri (Kemendagri), Jakarta, Senin (11/12/2023). Selain Sulut, Mendagri menambahkan, masih ada sejumlah daerah yang nilai IPH-nya cukup tinggi, salah satunya Kabupaten Minahasa sebesar 7,21 persen. Melihat kondisi itu, Mendagri meminta kepala daerah segera mencari solusi dan melakukan koordinasi dengan Badan Pusat Statistik (BPS) daerah untuk mengendalikan IPH. Langkah itu dibutuhkan agar tidak menganggu stabilitas ekonomi di daerah tersebut. “Kabupaten Minahasa, IPHnya minggu lalu 7,21 persen, tinggi sekali, 7,21 persen itu sudah mendekati angka 10 persen itu mendekati inflasi yang mulai mengganggu, mengganggu daya beli masyarakat dan sendi ekonomi, ini mohon maaf Bapak Bupati tolong dilihat betul kenapa angkanya begitu, atau angkanya yang salah,” ujarnya. Dalam kesempatan itu, Mendagri juga menyoroti daerah lain yang tingkat IPH-nya di atas 5 persen. Daerah itu seperti Halmahera Selatan 6,49 persen, Donggala 6,31 persen, Tomohon 6,05 persen, Bolaang Mongondow 5,82 persen, Bone Bolango 5,53 persen, Gorontalo 5,49 persen, Bitung 5,38 persen, dan Luwu 5,31 persen. Sementara itu, kabupaten/ kota dengan penurunan IPH tertinggi di antaranya Bandung Barat -6,24 persen, Lombok Timur -5,80 persen, Muna Barat -4,62 persen, Lombok Barat -4,28 persen, Boalemo -3,47 persen, Pasuruan -2,74 persen, Sarolangun -2,34 persen, Ogan komering Ulu Selatan -2,20 persen, Lembata -2,02 persen, dan Buton Tengah -1,98 persen. “Kabupaten Bandung Barat juga bagus IPH-nya juga turun di angka minus 6,24 persen, angka yang cukup dalam ini, saya memberikan apresiasi bukan karena Pj.-nya dari Kemendagri, memang faktanya dari BPS ini, kemudian Kota Pagar Alam yang beberapa minggu lalu tertinggi, nah ini sudah bisa memperbaiki, bagus, minus 1,65 persen,” ungkapnya. Sementara itu di tempat yang sama, Pelaksana Tugas (Plt.) Kepala BPS Amalia Adininggar Widyasanti mengatakan, komoditas yang memberikan andil terbesar terhadap kenaikan IPH di beberapa daerah adalah cabai rawit, cabai merah, dan bawang merah. Dirinya menuturkan, berdasarkan data BPS pada minggu pertama Desember 2023 kenaikan harga cabai merah terjadi di 347 kabupaten/kota. “Perkembangan IPH minggu pertama bulan Desember, terjadi kenaikan harga cabai merah pada 347 kabupaten/kota, dan 10 kenaikan tertinggi ada di Kabupaten Halmera Selatan, Manado, Tidore Kepulauan, Ternate, Tarakan, Pamekasan, Musi Rawas Utara, dan Bangkalan,” pungkasnya.   \n"
    );
    const hightlight_word = ref(word.value);
    const selection_word = ref("");
    const start_index = ref(0);
    const end_index = ref(0);
    const temp_start_index = ref(0);
    const temp_end_index = ref(0);
    const temp_label = ref("");
    const label_selected = ref("");
    const selection_data = ref<any>([]);
    const temp_selection_data = ref<any>([]);
    const opacity = ref(0);
    const show_selector = ref(false);

    const handleMouseUp = () => {
      const selection = window.getSelection();
      if (selection) {
        show_selector.value = true;
        opacity.value = 1;
        selection_word.value = selection.toString().trim();
        // SET REAL INDEX
        start_index.value = selection.anchorOffset;
        end_index.value = selection.focusOffset;
        const range = window.getSelection()?.getRangeAt(0);
        const rect = range?.getBoundingClientRect();
        const select = document.getElementById("label-selector");
        if (select) {
          select.style.position = "absolute";
          select.style.left = `${rect?.left}px`;
          select.style.top = `${rect?.bottom}px`;
        }
      }
    };
    const handleSelectChange = () => {
      temp_label.value = label_selected.value;
      const data = [start_index.value, end_index.value, temp_label.value];
      // const temp_data = [
      //   temp_start_index.value,
      //   temp_end_index.value,
      //   temp_label.value,
      // ];
      label_selected.value = "";
      selection_data.value.push(data);
      highlightedText();
      // temp_selection_data.value.push(temp_data);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
      }
      opacity.value = 0;
      show_selector.value = false;
    };
    const deleteElement = (index: number) => {
      const type = temp_selection_data.value[index][2];
      if (index < temp_selection_data.value.length - 1) {
        for (let i = index + 1; i < temp_selection_data.value.length; i++) {
          if (type == "SOURCE") {
            temp_selection_data.value[i][0] -= 41;
            temp_selection_data.value[i][1] -= 41;
          } else if (type == "CUE") {
            temp_selection_data.value[i][0] -= 38;
            temp_selection_data.value[i][1] -= 38;
          } else if (type == "CONTENT") {
            temp_selection_data.value[i][0] -= 42;
            temp_selection_data.value[i][1] -= 42;
          }
        }
      }
      selection_data.value.splice(index, 1);
      temp_selection_data.value.splice(index, 1);
    };
    function highlightedText() {
      for (let i = 0; i < selection_data.value.length; i++) {
        console.log(selection_data.value[i]);
        const start = selection_data.value[i][0];
        const end = selection_data.value[i][1];
        const type = selection_data.value[i][2];
        console.log(type);

        const openTag = `<span class="${type} rounded px-1">`;
        const closeTag = "</span>";

        hightlight_word.value =
          word.value.substring(0, start) +
          openTag +
          word.value.substring(start, end) +
          closeTag +
          word.value.substring(end);
      }
      // let highlighted = word.value;
      // temp_selection_data.value.forEach((el) => {
      //   const start = el[0];
      //   const end = el[1];
      //   const type = el[2];

      //   const openTag = `<span class="${type} rounded px-1">`;
      //   const closeTag = "</span>";

      //   highlighted =
      //     highlighted.substring(0, start) +
      //     openTag +
      //     highlighted.substring(start, end) +
      //     closeTag +
      //     highlighted.substring(end);
      // });
      // hightlight_word.value = highlighted;
      // return highlighted;
    }
    onMounted(() => {
      setCurrentPageTitle("Labeling Text");
      // document.addEventListener("click", function (evt) {
      //   var flyoutEl = document.getElementById("label-selector"),
      //     targetEl = evt.target;
      //   if (targetEl == flyoutEl) {
      //     console.log("di dalam");
      //   } else {
      //     const selection = window.getSelection();
      //     if (selection) {
      //       selection.removeAllRanges();
      //     }
      //     if (!selection) {
      //       opacity.value = 0;
      //     }
      //   }
      // });
    });
    return {
      word,
      hightlight_word,
      selection_word,
      start_index,
      end_index,
      temp_start_index,
      temp_end_index,
      temp_label,
      label_selected,
      selection_data,
      temp_selection_data,
      opacity,
      show_selector,
      handleMouseUp,
      handleSelectChange,
      highlightedText,
      deleteElement,
    };
  },
});
